/**
 * 跨应用共享的「契约型」常量（品牌、路径前缀等）。
 * 禁止在此包引入 Vue / Three / Nuxt 相关依赖，避免营销与编辑器构建图耦合。
 */

/** 对外品牌名（meta title、JSON-LD 等复用） */
export const SITE_BRAND_NAME = 'Animock' as const

/**
 * 编辑器在站点中的挂载前缀（需与 `apps/editor` 的 Vite `base` 保持一致）。
 * @see apps/editor/vite.config.ts
 */
export const EDITOR_PATH_PREFIX = '/editor/' as const

/**
 * 编辑器入口在营销站同源下的路径前缀（含末尾 `/`）。
 * 与营销站 `@nuxtjs/i18n` 的 `prefix_except_default` 对齐：`en` 无前缀，`zh-CN`/`ja` 带路径段。
 *
 * @param marketingLocaleCode - 营销站 `useI18n().locale`（如 `en`、`zh-CN`、`ja`）
 */
export function editorAppBasePathForMarketingLocale(marketingLocaleCode: string): string {
  const c = marketingLocaleCode.trim().toLowerCase().replace('_', '-')
  if (c === 'zh-cn') return `${EDITOR_PATH_PREFIX}zh-CN/`
  if (c === 'ja') return `${EDITOR_PATH_PREFIX}ja/`
  return EDITOR_PATH_PREFIX
}

/**
 * 营销站跳转编辑器时，URL 查询参数名（与编辑器深链解析共用）。
 */
export const EDITOR_TEMPLATE_SLUG_QUERY_KEY = 'template' as const
